export default {"src":"/_next/static/media/it.136727c8.svg","height":341,"width":512,"blurWidth":0,"blurHeight":0};